import { render, staticRenderFns } from "./CourseV2.vue?vue&type=template&id=32182578&"
import script from "./CourseV2.vue?vue&type=script&lang=ts&"
export * from "./CourseV2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports